import { ModelInstance, BaseModel, ToFrontHook, ToBackHook, listField } from './util';

@ModelInstance({
  mappingFields: {
    stage_id: 'stageId',
    tours_count: 'toursCount',
    playoff_stages_count: 'playoffStagesCount',
    playoff_teams_count: 'playoffTeamsCount',
  }
})
export class GameTimelineStageItem {
  stageId: number;
  toursCount: number;
  playoffStagesCount: number;
  playoffTeamsCount: number;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}

@ModelInstance({
  mappingFields: {
    tours_count: 'toursCount',
    playoff_stages_count: 'playoffStagesCount',
    playoff_teams_count: 'playoffTeamsCount',
    current_tour: 'currentTour',
    current_playoff_stage: 'currentPlayoffStage',
    current_playoff_round: 'currentPlayoffRound',
    stages: 'stages',
    tournament_stage_id: 'tournamentStageId',
    tournament_round_id: 'tournamentRoundId',
  },
  relation: {
    stages: listField(GameTimelineStageItem)
  }
})
export class GameTimelineStages extends BaseModel {
  toursCount: number;
  playoffStagesCount: number;
  playoffTeamsCount: number;
  currentTour: number;
  currentPlayoffStage: number;
  currentPlayoffRound: number;
  stages: GameTimelineStageItem[];
  tournamentStageId: number;
  tournamentRoundId: number;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
